<div *ngIf="verificationBanner" class="mb-3">
  <common-validation-card *ngIf="verificationBanner === 'Denied'" [messages]="bannerMessages" [showX]="false"> </common-validation-card>

  <div [routerLink]="['verification']" class="alert alert-warning font-weight-light cursor-pointer" role="alert" *ngIf="verificationBanner === 'Unverified'">
    Your Rubbl account is unverified. Click here to upload required documents.
  </div>
</div>
